export const getViewUrl = ({
  language,
  slug,
}: {
  language: string;
  slug: string;
}) => {
  return `https://${
    language === 'en' ? 'www' : language
  }.wix.com/website-template/view/html/${slug}`;
};
